import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import type { DynamicModuleDefinition } from "@modules/dynamic_import/types";
import { defineModule } from "@modules/dynamic_import/utils/defineModule";

export const RewardsHubWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_HUB_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsHubWidget" */ "../widgets/rewards_hub_widget/RewardsHubWidget"
        ),
});

export const RewardsEarnPointsProductPageWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_EARN_POINTS_PRODUCT_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsEarnPointsProductPageWidget" */ "../widgets/rewards_earn_points_product_page_widget/RewardsEarnPointsProductPageWidget"
        ),
});

export const RewardsEarnPointsCartWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_EARN_POINTS_CART_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsEarnPointsCartWidget" */ "../widgets/rewards_cart_widgets/rewards_earn_points_cart_widget/RewardsEarnPointsCartWidget"
        ),
});

export const RewardsCustomerPointsBalanceInlineWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_CUSTOMER_POINTS_BALANCE_INLINE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsCustomerPointsBalanceInlineWidget" */ "../widgets/rewards_inline_widgets/rewards_customer_points_balance_inline_widget/RewardsCustomerPointsBalanceInlineWidget"
        ),
});

export const RewardsJoinNowModalWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_JOIN_NOW_MODAL_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsJoinNowModalWidget" */ "../widgets/rewards_join_now_modal_widget/RewardsJoinNowModalWidget"
        ),
});

export const RewardsLoyaltyInfoPageWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_LOYALTY_INFO_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsLoyaltyInfoPageWidget" */ "../widgets/rewards_loyalty_info_page_widget/v1/RewardsLoyaltyInfoPageWidget"
        ),
});

export const RewardsLoyaltyInfoPageWidgetV2Definition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_LOYALTY_INFO_PAGE_WIDGET_V2,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsLoyaltyInfoPageWidgetV2" */ "../widgets/rewards_loyalty_info_page_widget/v2/RewardsLoyaltyInfoPageWidgetV2"
        ),
});

export const RewardsAvailableRewardsPageWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_AVAILABLE_REWARDS_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsAvailableRewardsPageWidget" */ "../widgets/rewards_page_widgets/widgets/rewards_available_rewards_page_widget/RewardsAvailableRewardsPageWidget"
        ),
});

export const RewardsAvailableRewardsPageWidgetModalDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_AVAILABLE_REWARDS_PAGE_WIDGET_MODAL,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsAvailableRewardsPageWidgetModal" */ "../widgets/rewards_page_widgets/widgets/rewards_available_rewards_page_widget_modal/RewardsAvailableRewardsPageWidgetModal"
        ),
});

export const RewardsEmptyStatePageWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_EMPTY_STATE_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsEmptyStatePageWidget" */ "../widgets/rewards_page_widgets/widgets/rewards_empty_state_page_widget/RewardsEmptyStatePageWidget"
        ),
});

export const RewardsReferralProgramPageWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_REFERRAL_PROGRAM_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsReferralProgramPageWidget" */ "../widgets/rewards_page_widgets/widgets/rewards_referral_program_page_widget/RewardsReferralProgramPageWidget"
        ),
});

export const RewardsReferralsPageWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_REFERRALS_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsReferralsPageWidget" */ "../widgets/rewards_page_widgets/widgets/rewards_referrals_page_widget/RewardsReferralsPageWidget"
        ),
});

export const RewardsHistoryPageWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_HISTORY_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsHistoryPageWidget" */ "../widgets/rewards_page_widgets/widgets/rewards_history_page_widget/RewardsHistoryPageWidget"
        ),
});

export const RewardsVipTiersPageWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_VIP_TIERS_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsVipTiersPageWidget" */ "../widgets/rewards_page_widgets/widgets/rewards_vip_tiers_page_widget/RewardsVipTiersPageWidget"
        ),
});

export const RewardsWaysToEarnPageWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_WAYS_TO_EARN_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsWaysToEarnPageWidget" */ "../widgets/rewards_page_widgets/widgets/rewards_ways_to_earn_page_widget/RewardsWaysToEarnPageWidget"
        ),
});

export const RewardsWaysToEarnPageWidgetModalDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_WAYS_TO_EARN_PAGE_WIDGET_MODAL,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsWaysToEarnPageWidgetModal" */ "../widgets/rewards_page_widgets/widgets/rewards_ways_to_earn_page_widget_modal/RewardsWaysToEarnPageWidgetModal"
        ),
});

export const RewardsWaysToSpendPageWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_WAYS_TO_SPEND_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsWaysToSpendPageWidget" */ "../widgets/rewards_page_widgets/widgets/rewards_ways_to_spend_page_widget/RewardsWaysToSpendPageWidget"
        ),
});

export const RewardsWaysToSpendPageWidgetModalDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_WAYS_TO_SPEND_PAGE_WIDGET_MODAL,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsWaysToSpendPageWidgetModal" */ "../widgets/rewards_page_widgets/widgets/rewards_ways_to_spend_page_widget_modal/RewardsWaysToSpendPageWidgetModal"
        ),
});

export const RewardsPopUpWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_POP_UP_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsPopUpWidget" */ "../widgets/rewards_popup_widget/RewardsPopUpWidget"
        ),
});

export const RewardsDrawerWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_DRAWER_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsDrawerWidget" */ "../widgets/rewards_drawer_widget/RewardsDrawerWidget"
        ),
});

export const RewardsQrCodeModalWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_QR_CODE_MODAL_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsQrCodeModalWidget" */ "../widgets/rewards_qr_code_modal_widget/RewardsQrCodeModalWidget"
        ),
});

export const RewardsVerifyAccountModalWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_VERIFY_ACCOUNT_MODAL_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsVerifyAccountModalWidget" */ "../widgets/rewards_verify_account_modal_widget/RewardsVerifyAccountModalWidget"
        ),
});

export const RewardsVipTiersCardWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_VIP_TIERS_CARD_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsVipTiersCardWidget" */ "../widgets/rewards_vip_tiers_card_widget/RewardsVipTiersCardWidget"
        ),
});

export const RewardsVipTiersSingleProgressWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_VIP_TIERS_SINGLE_PROGRESS_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsVipTiersSingleProgressWidget" */ "../widgets/rewards_vip_tiers_single_progress_widget/v1/RewardsVipTiersSingleProgressWidget"
        ),
});

export const RewardsVipTiersSingleProgressWidgetV2Definition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_VIP_TIERS_SINGLE_PROGRESS_WIDGET_V2,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsVipTiersSingleProgressWidgetV2" */ "../widgets/rewards_vip_tiers_single_progress_widget/v2/RewardsVipTiersSingleProgressWidgetV2"
        ),
});

export const RewardsVipTiersMultiProgressWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_VIP_TIERS_MULTI_PROGRESS_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsVipTiersMultiProgressWidget" */ "../widgets/rewards_vip_tiers_multi_progress_widget/RewardsVipTiersMultiProgressWidget"
        ),
});

export const RewardsFaqPageWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_FAQ_PAGE_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsFaqPageWidget" */ "../widgets/rewards_page_widgets/widgets/rewards_faq_page_widget/RewardsFaqPageWidget"
        ),
});

export const RewardsAvailableRewardsListWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_AVAILABLE_REWARDS_LIST_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsAvailableRewardsListWidget" */ "../widgets/rewards_available_rewards_list_widget/RewardsAvailableRewardsListWidget"
        ),
});

export const RewardsAvailableRewardsCartWidgetDefinition = defineModule({
    name: REWARDS_WIDGET_NAMES.REWARDS_AVAILABLE_REWARDS_CART_WIDGET,
    importCallback: () =>
        import(
            /* webpackChunkName: "RewardsAvailableRewardsCartWidget" */ "../widgets/rewards_cart_widgets/rewards_available_rewards_cart_widget/AvailableRewardsCartWidget"
        ),
});

export const definitions: Array<DynamicModuleDefinition> = [
    RewardsEarnPointsProductPageWidgetDefinition,
    RewardsEarnPointsCartWidgetDefinition,
    RewardsCustomerPointsBalanceInlineWidgetDefinition,
    RewardsJoinNowModalWidgetDefinition,
    RewardsLoyaltyInfoPageWidgetDefinition,
    RewardsLoyaltyInfoPageWidgetV2Definition,
    RewardsAvailableRewardsPageWidgetDefinition,
    RewardsAvailableRewardsPageWidgetModalDefinition,
    RewardsEmptyStatePageWidgetDefinition,
    RewardsReferralProgramPageWidgetDefinition,
    RewardsReferralsPageWidgetDefinition,
    RewardsHistoryPageWidgetDefinition,
    RewardsVipTiersPageWidgetDefinition,
    RewardsWaysToEarnPageWidgetDefinition,
    RewardsWaysToEarnPageWidgetModalDefinition,
    RewardsWaysToSpendPageWidgetDefinition,
    RewardsWaysToSpendPageWidgetModalDefinition,
    RewardsHubWidgetDefinition,
    RewardsPopUpWidgetDefinition,
    RewardsDrawerWidgetDefinition,
    RewardsQrCodeModalWidgetDefinition,
    RewardsVerifyAccountModalWidgetDefinition,
    RewardsVipTiersCardWidgetDefinition,
    RewardsVipTiersSingleProgressWidgetDefinition,
    RewardsVipTiersSingleProgressWidgetV2Definition,
    RewardsVipTiersMultiProgressWidgetDefinition,
    RewardsFaqPageWidgetDefinition,
    RewardsAvailableRewardsListWidgetDefinition,
    RewardsAvailableRewardsCartWidgetDefinition,
];
